import SignUp from './illustrations/SignUp.svg'
import SignIn from './illustrations/SignIn.svg'

export * from './icons/CloseIcon'

export const Illustrations = {
  SignUp,
  SignIn,
}
